// extracted by mini-css-extract-plugin
module.exports = {"head":"e_ar"};